module.exports = "https://s91588.cdn.ngenix.net/microcredits-frontend/_next/static/images/esbBanner-5d9ec5202bd36e20cdbc5ffaa7348985.png";